export const consultantRoutes = [
    {
        path: 'consultant/center',
        name: 'ConsultantCenter',
        component: () => import('./views/ConsultantCenter.vue')
    },
    {
        path: 'consultant/timesheet',
        name: 'EmployeeTimeSheet',
        component: () => import('./views/EmployeeTimeSheet.vue')
    },
    {
        path: 'consultant/timesheet-summary',
        name: 'TimesheetSummary',
        component: () => import('./views/TimesheetSummary.vue')
    },
    {
        path: 'consultant/hr-timesheets',
        name: 'HRTimesheets',
        component: () => import('./views/HRTimesheets.vue')
    },
    {
        path: 'consultant/hr-timesheets-details',
        name: 'HRTimesheetsDetails',
        component: () => import('./views/HRTimesheetsDetails.vue')
    },
    {
        path: 'consultant/invoice',
        name: 'ConsultantInvoice',
        component: () => import('./views/ConsultantInvoice.vue')
    },
    {
        path: 'consultant/list',
        name: 'ConsultantsList',
        component: () => import('./views/ConsultantsList.vue')
    },
    {
        path: 'consultant/receive-payment',
        name: 'ConsultantReceivePayment',
        component: () => import('./views/ConsultantReceivePayment.vue')
    },
    {
        path: 'consultant/add-customer-consultant',
        name: 'AddCustomerConsultant',
        component: () => import('@/modules/customer/views/CustomerAddConsultant.vue')
    },
    {
        path: 'consultant/add-multiple-customer-consultant',
        name: 'AddMultipleCustomerConsultant',
        component: () => import('@/modules/customer/views/AddMultipleCustomerConsultant.vue')
    },
    {
        path: 'consultant/import-rewa-hr-timesheet',
        name: 'ImportRewaHRTimesheet',
        component: () => import('./views/ImportRewaHRTimesheet.vue')
    },
    {
        path: 'consultant/contract-details',
        name: 'ConsultantContractDetails',
        component: () => import('./views/ConsultantContractDetails.vue')
    },
    {
        path: 'consultant/contract-tracking',
        name: 'ConsultantContractTracking',
        component: () => import('./views/ConsultantContractTracking.vue')
    },
    {
        path: 'consultant/benefits',
        redirect: { name: 'BenefitTypes' }
    },
    {
        path: 'consultant/benefits/types',
        name: 'BenefitTypes',
        component: () => import('./views/BenefitTypes.vue')
    },
    {
        path: 'consultant/benefits/plans',
        name: 'BenefitPlans',
        component: () => import('./views/BenefitPlans.vue')
    },
    {
        path: 'consultant/benefits/category',
        redirect: { name: 'BenefitTypes' }
    },
    {
        path: 'consultant/payroll',
        redirect: { name: 'PayrollHistory' }
    },
    {
        path: 'consultant/payroll/history',
        name: 'PayrollHistory',
        component: () => import('./views/PayrollHistory.vue')
    },
    {
        path: 'consultant/payroll/staging',
        name: 'PayrollStaging',
        component: () => import('./views/PayrollStaging.vue')
    },
    {
        path: 'consultant/payroll/to-consultants',
        name: 'PayrollToConsultants',
        component: () => import('./views/PayrollStagingConsultantPreview.vue')
    },
    {
        path: 'consultant/payroll/staging/:batchId/consultants',
        redirect: (to) => ({
            name: 'PayrollToConsultants',
            query: { batchId: to.params.batchId }
        })
    },
    {
        path: 'consultant/payroll/record',
        name: 'RecordPayroll',
        component: () => import('./views/RecordPayroll.vue')
    },
    {
        path: 'consultant/payroll/record/manual',
        name: 'RecordPayrollManual',
        component: () => import('./views/RecordPayrollManual.vue')
    }
];
